// extracted by mini-css-extract-plugin
export default {"text_skills":"Self_Info_text_skills__RlPgm","text_skills_active":"Self_Info_text_skills_active__zo5M1","fadein":"Self_Info_fadein__y0ePa"};